import React from 'react';
import { capitalize } from '../helpers'
import swal from 'sweetalert'
import { connect } from 'react-redux';
import {
  batch_update_entries
} from '../actions'

const mapDispatchToProps = dispatch => {
  return {
    batchUpdate: (feed_id, filters, operations, dry) => dispatch( batch_update_entries(feed_id, filters, operations, dry) )
  }
}

class ConnectedFiltersUpdate extends React.Component {
  batchUpdate() {
    const { feed_id, filters, operations } = this.props
    this.props.batchUpdate(feed_id, filters, operations, false)
  }

  dryBatchUpdate() {
    const { feed_id, filters, operations } = this.props
    this.props.batchUpdate(feed_id, filters, operations, true)
  }

  operator(operation, append, column, value=null, pattern="") {
    const col = (column === "newentry") ? "New Entry" : capitalize(column)
    const operators = {
      "set": (
        <div className="col s11">
          <span className="operatorColumn mr15">Set</span>
          <span className="fieldColumn mr15">{ col }</span>
          <span className="operatorColumn mr15">to</span>
          <span className="valueColumn">{value}</span>
        </div>
      ),
      "clear": (
        <div className="col s11">
          <span className="operatorColumn mr15">Clear column</span>
          <span className="fieldColumn mr15">{ col }</span>
        </div>
      ),
      "replace": (
        <div className="col s11">
          <span className="fieldColumn mr15">In { col }</span>
          <span className="operatorColumn mr15">Replace pattern</span>
          <span className="valueColumn mr15">{pattern}</span>
          <span className="operatorColumn mr15">with</span>
          <span className="valueColumn mr15">{value}</span>
        </div>
      ),
      "append": (
        <div className="col s11">
          <span className="valueColumn mr15">{value}</span>
          <span className="operatorColumn mr15">will be appended to</span>
          <span className="fieldColumn mr15">{ col }</span>
        </div>
      ),
      "prepend": (
        <div className="col s11">
        <span className="valueColumn mr15">{value}</span>
        <span className="operatorColumn mr15">will be prepended to</span>
        <span className="fieldColumn mr15">{ col }</span>
        </div>
      ),
      "append_field": (
        <div className="col s11">
          <span className="fieldColumn mr15">Value of {capitalize(append)}</span>
          <span className="operatorColumn mr15">will be appended to</span>
          <span className="fieldColumn mr15">{ col }</span>
        </div>
      ),
      "prepend_field": (
        <div className="col s11">
          <span className="fieldColumn mr15">Value of {capitalize(append)}</span>
          <span className="operatorColumn mr15">will be prepended to</span>
          <span className="fieldColumn mr15">{ col }</span>
        </div>
      ),
      "revert_row": (
        <div className="col s11">
          <span className="operatorColumn mr15">Revert row to its original values</span>
        </div>
      ),
      "revert_column": (
        <div className="col s11">
          <span className="fieldColumn mr15">{ col }</span>
          <span className="operatorColumn mr15">will be reverted to its original value</span>
        </div>
      ),
      "revert_append": (
        <div className="col s11">
          <span className="fieldColumn mr15">{ col }</span>
          <span className="operatorColumn mr15">will be reverted to its original value and</span>
          <span className="valueColumn mr15">{value}</span>
          <span className="operatorColumn mr15">will be appended to it</span>
        </div>
      ),
      "revert_prepend": (
        <div className="col s11">
          <span className="fieldColumn mr15">{ col }</span>
          <span className="operatorColumn mr15">will be reverted to its original value and</span>
          <span className="valueColumn mr15">{value}</span>
          <span className="operatorColumn mr15">will be prepended to it</span>
        </div>
      ),
    }
    return operators[operation]
  }

  render() {

    const {operations} = this.props

    if (operations.length === 0) {
      return ''
    }

    return (
      <React.Fragment>
        <div className="row filtersHead">
          <div className="col s12 l12 xl12">
            <span className="filterTitle">What to update</span>
          </div>
        </div>
        {
          operations.map( (currentOperation) => {
            const {key, append, field, operation, value, pattern} = currentOperation
            const fieldRow = this.operator(operation, append, field, value, pattern)

            return (
              <div className="row" key={key}>
                <div className="col s1">
                  <a href="" onClick={(e) => {
                    e.preventDefault()
                    this.props.removeOperation(key)
                  }}>
                    <i className="material-icons c-red" title="Remove Filter">cancel</i>
                  </a>
                </div>
                { fieldRow }
              </div>
            )
          }
        )
      }

      <a href="" className="btn red darken-1 waves-effect waves-light mr-10" onClick={(e)=>{
        e.preventDefault()
        this.dryBatchUpdate()
      }}><i className="material-icons right">security</i>Dry run</a>

      <a href="" className="btn red darken-1 waves-effect waves-light" onClick={(e)=>{
        e.preventDefault()
        swal({
          title: "Apply operations?",
          text: `Are you sure that you want to apply these operations?\nThis cannot be undone.`,
          icon: "warning",
          // buttons: [true, true ],
          buttons: {
            cancel: {
              text: "Cancel",
              value: null,
              visible: true,
              className: "btn red darken-1 waves-effect waves-light",
              closeModal: true,
            },
            confirm: {
              text: "OK",
              value: true,
              visible: true,
              className: "btn red darken-1 waves-effect waves-light",
              closeModal: true
            }
          },
          // dangerMode: true
        }).then(willDelete => {
          if (willDelete) {
            this.batchUpdate()
          }
        });
      }}><i className="material-icons right mr-10">done_all</i>Apply</a>


      </React.Fragment>
    )
  }
}

const FiltersUpdate = connect(null, mapDispatchToProps)(ConnectedFiltersUpdate)

export default FiltersUpdate



// WEBPACK FOOTER //
// ./src/js/components/FiltersUpdate.js